import React, { useState } from 'react';
import styles from './EditModal.module.css';

type Props = {
  columns: string[];
  initialData: Record<string, any>;
  isCreating: boolean;
  onSave: (data: Record<string, any>) => void;
  onClose: () => void;
};

// Fields that should not be edited manually
const READONLY_FIELDS = ['id', 'created_at', 'updated_at', 'uuid'];

export default function EditModal({ columns, initialData, isCreating, onSave, onClose }: Props) {
  const [form, setForm] = useState<Record<string, any>>(
    Object.fromEntries(columns.map(col => [col, initialData[col] ?? '']))
  );

  function handleChange(col: string, value: string) {
    setForm(prev => ({ ...prev, [col]: value }));
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    // Strip readonly fields on create
    const payload = isCreating
      ? Object.fromEntries(Object.entries(form).filter(([k]) => !READONLY_FIELDS.includes(k)))
      : form;
    onSave(payload);
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-box ${styles.box}`} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{isCreating ? '새 레코드 추가' : '레코드 편집'}</h2>
          <button className="btn btn-ghost" style={{ padding: '6px 10px' }} onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.fields}>
            {columns.map(col => {
              const isReadonly = READONLY_FIELDS.includes(col) && isCreating;
              return (
                <div key={col} className={styles.field}>
                  <label className={styles.label}>
                    {col}
                    {READONLY_FIELDS.includes(col) && (
                      <span className={styles.badge}>auto</span>
                    )}
                  </label>
                  <input
                    className="input"
                    value={form[col] ?? ''}
                    onChange={e => handleChange(col, e.target.value)}
                    disabled={isReadonly}
                    placeholder={isReadonly ? 'auto-generated' : col}
                  />
                </div>
              );
            })}
          </div>

          <div className={styles.footer}>
            <button type="button" className="btn btn-ghost" onClick={onClose}>취소</button>
            <button type="submit" className="btn btn-primary">
              {isCreating ? '추가하기' : '저장하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
